export const apiRoutes = {
    chat: '/api/v1/chat/web',
    chatApp: '/api/v1/chat/app',
    chatBanner: '/api/v1/chat/banner',
    signUrl: '/api/v1/sign-url',
    conversation: '/api/v1/chat/web/conversation',
    chatUpload: '/api/v1/chat/upload',
    logout: '/api/v1/chat/logout'
}